<template>
    <div class="main-cn">
        <div class="main-hd">
            <h4>我的线索</h4>
        </div>

        <div class="main-bd mg20">
            <el-row class="searchSection">
                <el-form ref="filterModel" :inline="true" :model="filterModel">
                    <el-form-item label="线索ID">
                        <el-input size="small" v-model="filterModel.id" placeholder="请输入线索ID"></el-input>
                    </el-form-item>
                    <el-form-item label="申请人" prop="contact_name">
                        <ContactClueSelect ref="ContactClueSelect" v-model="filterModel.contact_name"
                                           @change="ContactClueHandleChange"></ContactClueSelect>
                    </el-form-item>
                    <el-form-item label="申请人电话" >
                        <el-input size="small" v-model="filterModel.mobile" placeholder="请输入电话"></el-input>
                    </el-form-item>
                    <el-form-item label="所在单位">
                        <AdressClueSelect ref="AdressClueSelect" v-model="filterModel.customer_name"
                                          @change="AdressClueHandleChange"></AdressClueSelect>
                    </el-form-item>
                    <el-form-item label="单位类型">
                        <el-select v-if="customer_types" size="small" v-model="filterModel.customer_type" placeholder="请选择">
                            <el-option v-for="(item, key) in customer_types" :key="key" :label="item" :value="key">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="产品类型" prop="product_id">
                        <el-select v-model="filterModel.product_id" size="small">
                            <el-option :value="product.id" v-for="(product,index) in productList" :key="index"
                                       :label="product.name"></el-option>
                        </el-select>
                    </el-form-item>
                    <span v-show="isCollapse">
                        <DistrictLinkage ref="DistrictLinkage" :provinceId="filterModel.province_id"
                                         :cityId="filterModel.city_id" :districtId="filterModel.district_id"
                                         @change="handleChange"></DistrictLinkage>

                        <el-form-item label="申请时间">
                            <el-date-picker
                                size="small"
                                v-model="filterModel.apply_time"
                                type="daterange"
                                format="yyyy-MM-dd"
                                value-format="yyyy-MM-dd"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>
                        <!-- <el-form-item label="起始日期" prop="start_time">
                            <el-date-picker
                                    size="small"
                                    v-model="filterModel.start_time"
                                    type="date"
                                    placeholder="选择起始日期">
                            </el-date-picker>
                        </el-form-item>

                        <el-form-item label="截止日期" prop="end_time">
                            <el-date-picker
                                    size="small"
                                    v-model="filterModel.end_time"
                                    type="date"
                                    placeholder="选择截止日期">
                            </el-date-picker>
                        </el-form-item> -->
                        <!-- <el-form-item label="来源" prop="source">
                            <el-select v-model="filterModel.source" size="small">
                                <el-option :value="0" label="全部"></el-option>
                                <el-option :value="key" v-for="(source, key) in sourceType" :key="key"
                                        :label="source"></el-option>
                            </el-select>
                        </el-form-item> -->
                        <el-form-item label="来源" prop="source">
                            <ChannelCascader ref="ChannelCascader" :channel="channel" @change="channelHandleChange"></ChannelCascader>
                        </el-form-item>
                        <el-form-item label="申请人真实性">
                            <ClueStatus ref="ClueStatus" v-model="filterModel.status" @change="statusHandleChange" key="1"></ClueStatus>
                        </el-form-item>
                        <el-form-item label="负责人真实性">
                            <ClueStatus ref="ClueLeaderStatus" v-model="filterModel.leader_status" @change="leaderStatusHandleChange" key="2"></ClueStatus>
                        </el-form-item>
                        <el-form-item label="关联状态">
                            <el-select v-model="filterModel.is_bind_customer">
                                <el-option label="不限"  value=""></el-option>
                                <el-option label="未关联"  value="0"></el-option>
                                <el-option label="已关联" value="1"></el-option>
                            </el-select>
                        </el-form-item>
                    </span>
                    <el-form-item>
                        <el-button type="primary" size="small" @click="submitSearch">搜索</el-button>
                        <el-button @click="resetForm()" size="small">重置</el-button>
                        <a class="searchCollapse" @click="collapse()">{{ searchTitle }}<i
                                :class="{ 'el-icon-fa-angle-down': isDown, 'el-icon-fa-angle-up': isUp }"></i></a>
                    </el-form-item>
                </el-form>
            </el-row>
            <el-row class="addBtn">
                <el-button type="primary" size="small"
                           @click="handleBatchSalers('转交业务员',{ name: 'transfer', args: clueIds })">批量转交
                </el-button>
                <el-button type="primary" size="small"  v-if="Acs('/sales-leads/query-repeat')" @click="showQueryRepeat = true">数据查重</el-button>
                <el-button v-if="Acs('/sales-leads/delete')" type="primary" size="small"
                           @click="handleBatchDelete(clueIds)">批量删除
                </el-button>
                <el-button type="primary" size="small" @click="addClue()">+ 新增线索</el-button>
                &nbsp;&nbsp;<UnbindDialog ref="UnbindDialog" :ids="clueIds" @change="unbindChange()"></UnbindDialog>
            </el-row>
            <el-table size="mini" style="width:100%" class="tabTopBorder" v-loading="loading"
                      @selection-change="handleSelectionChange" :data="cluesList">
                <el-table-column prop="id" type="selection"></el-table-column>
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column prop="contact_name" label="申请人"></el-table-column>
                <el-table-column prop="mobile" label="申请人电话" width="170">
                    <template slot-scope="scope">
                        <span>{{scope.row.mobile}}</span>
                        <el-button v-if="scope.row.mobile != ''" type="text" size="mini" icon="el-icon-unlock" @click="unlockMobile(scope.row)">解密</el-button>
                    </template>
                </el-table-column>
                <el-table-column label="所在单位">
                    <template slot-scope="scope">
                        {{scope.row.customer_name}}
                        <i v-if="scope.row.customer_id > 0" style="color: #67C23A;" class="el-icon-circle-check">已关联</i>
                        <i v-else style="color: #F56C6C;" class="el-icon-circle-close">未关联</i>
                    </template>
                </el-table-column>
                <el-table-column prop="customer_type_name" label="单位类型"></el-table-column>
                <el-table-column label="绑定客户名称">
                    <template slot-scope="scope">
                        <span class="el-dropdown-link customer-name" v-if="scope.row.customer">
                            <router-link target="_blank" :to="{path: '/customers/view', query: {id: scope.row.customer_id}}" style="color: #409EFF;">
                                {{scope.row.customer.name}}
                            </router-link>
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="district_names" label="所在地区"></el-table-column>
                <el-table-column label="申请时间">
                    <template slot-scope="scope">
                        <time>{{ scope.row.created_at | date }}</time>
                    </template>
                </el-table-column>
                <el-table-column label="申请产品">
                    <template slot-scope="scope">
                        <div v-for="product in scope.row.products" :key="product.product_id">
                            <div v-if="scope.row.products.length == 1">
                                <el-tag>{{ product.product_name }}</el-tag>
                            </div>
                        </div>
                        <div v-if="scope.row.products.length > 1">
                            <el-tooltip class="item" effect="dark" placement="bottom">
                                <div slot="content" v-for="product in scope.row.products" :key="product.product_id"
                                     class="line-gap">{{product.product_name}}
                                </div>
                                <el-tag>{{ scope.row.products[0].product_name }}...</el-tag>
                            </el-tooltip>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="bind_at" label="线索绑定时间"></el-table-column>
                <el-table-column prop="username" label="业务员">
                    <template slot-scope="scope">
                        <el-tooltip v-if="scope.row.last_visit" class="item" effect="light"
                                    :content="scope.row.last_visit.content" placement="top">
                            <el-link type="primary">{{scope.row.last_visit.created_at}}</el-link>
                        </el-tooltip>
                        <span v-else>暂无回访</span>
                    </template>
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.user_id == 0 && scope.row.is_deleted == 0" type="primary" plain size="small"
                                   @click="handleSalers('绑定业务员',{ name: 'bind', args: clueIds }, scope.row )">绑定
                        </el-button>
                        <div v-else>
                            <el-tooltip v-if="scope.row.bind_at != ''" class="item" effect="light"
                                        :content="'绑定时间：' + scope.row.bind_at" placement="top">
                                <el-link type="primary">{{scope.row.username}}</el-link>
                            </el-tooltip>
                            <span v-else>{{scope.row.username}}</span>
                            <el-button v-if="scope.row.is_deleted == 0" @click="unbind([scope.row.id])" type="text"
                                       size="medium" style="color: #F56C6C;font-weight: 900" class="el-icon-close">
                            </el-button>
                            <i v-if="scope.row.is_deleted == 0" class="el-icon-fa-arrow-right" style="color: #F56C6C; cursor: pointer;margin-left:5px;"
                               title="转移给其他业务员"
                               @click="handleSalers('转交业务员', { name: 'transfer', args: clueIds }, scope.row )"></i>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="status_str" label="申请人真实性"></el-table-column>
                <el-table-column prop="leader_status_str" label="负责人真实性"></el-table-column>
                <el-table-column prop="source_name" label="来源"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleView(scope.row)">查看</el-button>
                        <el-button type="text" v-if="scope.row.is_deleted == 0" size="small" @click="handleEdit(scope.row)">编辑</el-button>
                        <el-button type="text" v-if="scope.row.is_deleted == 0" size="small" @click="handleDelete(clueIds,scope.row)">删除</el-button>
                        <el-button type="primary" v-if="scope.row.customer_id == 0 && scope.row.is_deleted == 0" size="mini"
                                   @click="handleContact(scope.row)" style="margin-top:10px;">关联客户
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-row v-if="linkPage">
                <pagination :linkPage="linkPage"></pagination>
            </el-row>
        </div>
        <!-- 绑定转移业务员 -->
        <assign-clue-dialog
                v-if="showAssign"
                :text="title"
                :actionYes="action_callback"
                @changeShow="changeShow1">
        </assign-clue-dialog>
        <!-- 关联客户 -->
        <contact-customer-dialog v-if="clueRow"
                :showDialog="showContact"
                :clue="clueRow"
                @changeShow="changeShow2"
                @saveCallback="saveCallback"
                :key="contact_customer_dialog_key">
        </contact-customer-dialog>

        <!-- 线索查重 -->
        <query-repeat v-if="showQueryRepeat" :display="showQueryRepeat" @watchQueryRepeatClose="watchQueryRepeatClose"></query-repeat>

    </div>
</template>
<script>
    import Pagination from "~/widgets/Pagination.vue";
    import ClueService from "~/services/SaleClues";
    import ProductService from "~/services/product";
    import DistrictLinkage from "~/widgets/DistrictLinkage.vue";
    import AssignClueDialog from "~/views/clue/dialog/assignClueDialog.vue";
    import ContactCustomerDialog from "~/views/clue/dialog/contactCustomerDialog.vue";
    import ContactClueSelect from "~/widgets/ClueContactSelect.vue"
    import AdressClueSelect from "~/widgets/ClueAdressSelect.vue"
    import QueryRepeat from "~/views/clue/dialog/QueryRepeat.vue";
    import CustomerService from "~/services/customer";
    import ChannelCascader from "~/widgets/ChannelCascader.vue";
    import UnbindDialog from "~/views/clue/dialog/unbindDialog.vue";
    import ClueStatus from "~/widgets/ClueStatus.vue";
    import ContactService from "~/services/contact";
    import moment from 'moment'
    import 'moment/locale/zh-cn'

    moment.locale('zh-cn')

    export default {
        data() {
            return {
                products: [],
                filterModel: {},
                userName: "",      //业务员姓名
                userList: [],      //用户列表
                loading: false,
                cluesList: [],     //销售线索列表
                productList: [],     //产品列表
                linkPage: null,       //分页信息
                clueIds: [],          //线索id容器，批量删除、绑定、转交用
                myClueId: "",         //当前线索id
                clueRow: null, // 当前选中的线索记录
                showAssign: false,
                showContact: false,
                multipleSelection: [],   //选中线索数组
                title: "",

                isCollapse: false,
                searchTitle: '展开',
                isDown: true,
                isUp: false,

                showQueryRepeat: false, // 显示查重窗口
                customer_types: {},
                sourceType: [], //来源
                channel: {
                    pid: 0,
                    id: 0,
                },
                contact_customer_dialog_key: 0,
            }
        },
        components: {
            DistrictLinkage,
            Pagination,
            AssignClueDialog,
            ContactCustomerDialog,
            ContactClueSelect,
            AdressClueSelect,
            QueryRepeat,
            ChannelCascader,
            UnbindDialog,
            ClueStatus
        },
        filters: {
            date(val) {
                return moment(val * 1000).format('YYYY-MM-DD HH:mm:ss');
            }
        },
        // 监听路由参数更新执行分页请求
        beforeRouteUpdate: function (to, from, next) {
            let params = this.filterModel;
            params['page'] = to.query["page"];
            params['perPage'] = to.query["perPage"];
            this.getSaleClues(params);
        },
        created() {
            if (this.filterModel == null) {
                this.filterModel = ClueService.getModel();
            }
            this.resetForm();
            this.getProducts();

            this.customer_types = CustomerService.getTypes(true);
            this.sourceType = ClueService.getSourceType();
        },
        methods: {
            // 获取所有产品
            getProducts() {
                ProductService.getOptionList().then(res => {
                    if (res.code == 0) {
                        this.productList = res.data;
                    }
                });
            },
            // 获取销售线索列表
            getSaleClues(params = {}) {
                this.loading = true;
                // 我的线索
                ClueService.getMyList(params).then(res => {
                    if (res.code == 0) {
                        this.cluesList = res.data;
                        if (res._meta) {
                            this.linkPage = res._meta;
                        }
                    }
                    this.loading = false;
                });
            },

            // 选中发生改变时候触发该事件
            handleSelectionChange(val) {
                this.multipleSelection = val;
                this.clueIds = [];
                let clueId = 0;
                this.multipleSelection.forEach((item, index) => {
                    clueId = item.id
                    this.clueIds.push(clueId);
                });
            },
            // 查看、编辑、删除、绑定、转交销售线索操作
            handleView(clue) {
                let routeData = this.$router.resolve({
                    path: "/sales-leads/view",
                    query: {id: clue.id, referer: this.$route.path},
                });
                window.open(routeData.href, '_blank');
            },
            handleEdit(clue) {
                let routeData = this.$router.resolve({
                    path: "/sales-leads/update",
                    query: {id: clue.id, referer: this.$route.path},
                });
                window.open(routeData.href, '_blank');
            },
            // 关联客户
            handleContact(clue) {
                this.contact_customer_dialog_key ++;
                this.showContact = true;
                this.myClueId = clue.id.toString();
                this.clueRow = clue;
            },
            saveCallback() {
                this.submitSearch();
            },
            action_callback() {
            },
            // 批量操作或者转交业务员
            handleBatchSalers(text, action) {
                if (this.multipleSelection.length == 0) {
                    this.$message({
                        message: '请先选中要操作的项',
                        type: 'warning'
                    });
                    return;
                }
                var _this = this;
                this.showAssign = true;
                this.action_callback = function (uid) {
                    let params = {
                        leads_ids: action.args,
                        // user_id: action.uid
                        // user_id: _this.currentUserId
                        user_id: uid
                    }
                    if (action.name == 'bind') {          //绑定业务员
                        ClueService.salesmanBind(params).then(res => {
                            if (res.code == 0) {
                                _this.$message({
                                    message: "批量绑定成功",
                                    type: "success"
                                });
                                _this.showAssign = false;
                                _this.submitSearch();
                            }
                        });
                    } else if (action.name == 'transfer') {    //转交业务员
                        ClueService.transferSalers(params).then(res => {
                            if (res.code == 0) {
                                _this.$message({
                                    message: "批量转交成功",
                                    type: "success"
                                });
                                _this.showAssign = false;
                                _this.submitSearch();
                            }
                        })
                    }
                }
                this.title = text;
            },
            // 单个操作或者转交业务员
            handleSalers(text, action, clue) {
                let _this = this;
                if (clue.id) {
                    this.clueIds.push(clue.id);
                }
                this.showAssign = true;
                this.action_callback = function (uid) {
                    let params = {
                        leads_ids: action.args,
                        // user_id: action.uid
                        // user_id: _this.currentUserId
                        user_id: uid
                    }
                    if (action.name == 'bind') {          //绑定业务员
                        ClueService.salesmanBind(params).then(res => {
                            if (res.code == 0) {
                                _this.$message({
                                    message: "绑定成功",
                                    type: "success"
                                });
                                _this.showAssign = false;
                                _this.submitSearch();
                            }
                        });
                    } else if (action.name == 'transfer') {    //转交业务员
                        ClueService.transferSalers(params).then(res => {
                            if (res.code == 0) {
                                _this.$message({
                                    message: "转交成功",
                                    type: "success"
                                });
                                _this.showAssign = false;
                                _this.submitSearch();
                            }
                        })
                    }
                }
                this.title = text;
                this.clueIds = [];
            },

            //单个删除
            handleDelete(leads_ids, myclue) {
                let _this = this;
                if (myclue.id) {
                    leads_ids.push(myclue.id);
                }
                this.$confirm("此操作是删除操作, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    center: true
                }).then(() => {
                    ClueService.deleteClues(leads_ids).then(res => {
                        if (res.code == 0) {
                            _this.cluesList = _this.cluesList.filter(clue => {
                                return clue.id != myclue.id;
                            });
                        }
                    });
                }).catch(() => {
                });
                this.clueIds = [];
            },

            //批量删除
            handleBatchDelete(leads_ids) {
                let _this = this;
                if (this.multipleSelection.length == 0) {
                    this.$message({
                        message: '请先选中要删除的项',
                        type: 'warning'
                    });
                    return;
                }
                this.$confirm("此操作是删除操作, 是否继续?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    center: true
                }).then(() => {
                    ClueService.deleteClues(leads_ids).then(res => {
                        if (res.code == 0) {
                            _this.multipleSelection.forEach((item, index) => {
                                _this.cluesList = _this.cluesList.filter(clue => {
                                    return clue != item;
                                });
                            });
                        }
                    });
                }).catch(() => {
                });
            },
            changeShow1(isShow) {
                this.showAssign = isShow;
            },
            changeShow2(isShow) {
                this.showContact = isShow;
            },
            //地区联动 Cascader 级联选择器,切换事件,表单model赋值
            handleChange(value) {
                this.filterModel.province_id = parseInt(value[0]);
                this.filterModel.city_id = parseInt(value[1]);
                this.filterModel.district_id = parseInt(value[2]);
            },

            //线索联系人远程搜索组件赋值
            ContactClueHandleChange(name) {
                this.filterModel.contact_name = name;
            },

            //线索联系人所在单位远程搜索组件赋值
            AdressClueHandleChange(name) {
                this.filterModel.customer_name = name;
            },

            resetForm() {
                // this.$refs["filterModel"].resetFields();
                this.filterModel = _.clone(_.extend(this.filterModel, {
                    id: '',
                    province_id: 0,
                    city_id: 0,
                    district_id: 0,
                    product_id: '',
                    // start_time: '',
                    // end_time: '',
                    apply_time: [],
                    contact_name: '',
                    customer_name: '',
                    mobile:'',
                    source: '',
                    is_bind_customer: '0'
                }));
                if(this.$refs["DistrictLinkage"]){
                    this.$refs["DistrictLinkage"].reset();
                }
                if(this.$refs["ContactClueSelect"]){
                    this.$refs["ContactClueSelect"].reset();
                }
                if(this.$refs["AdressClueSelect"]){
                    this.$refs["AdressClueSelect"].reset();
                }
                if(this.$refs["ChannelCascader"]){
                    this.$refs["ChannelCascader"].reset();
                }
                if(this.$refs["ClueStatus"]){
                    this.$refs["ClueStatus"].reset();
                }
                if(this.$refs["ClueLeaderStatus"]){
                    this.$refs["ClueLeaderStatus"].reset();
                }
                this.submitSearch();
            },

            //筛选查询
            submitSearch() {
                var params = _.clone(this.filterModel);
                _.each(params, (val, key) => {
                    // 如果值是假值，除了数字 0 和字符串 '0'，都删除该键
                    if (val === undefined || val === null || (typeof val === 'string' && val === '')) {
                        delete params[key];
                    }
                })
                this.getSaleClues(params);
            },

            addClue() {
                this.$router.push({
                    path: "/sales-leads/create",
                    query: {
                        referer: this.$route.path,
                    }
                })
            },

            collapse() {
                this.isCollapse = !this.isCollapse;
                if (this.isCollapse) {
                    this.searchTitle = "收起";
                    this.isUp = true;
                    this.isDown = false;
                } else {
                    this.searchTitle = "展开";
                    this.isUp = false;
                    this.isDown = true;
                }
            },

            unbind(ids) {
                this.clueIds = ids;
                this.$refs["UnbindDialog"].show();
                // this.$confirm("确定要解绑该条销售线索？", "温馨提示", {type: "warning"}).then(ok => {
                //     ClueService.salesmanUnbind({
                //         "leads_ids": ids
                //     }).then(res => {
                //         if (res.code == 0) {
                //             this.$message.success('解绑成功');
                //             this.submitSearch();
                //         }
                //     }).catch(err => {
                //         console.error(err);
                //     })

                // }).catch(cancel => {
                //     return false;
                // });
            },

            watchQueryRepeatClose() {
                this.showQueryRepeat = false;
            },

            unlockMobile(row) {
                ContactService.decodeMobile({id: row.id, type: 3}).then(res => {
                    if (res.code == 0 && res.data) {
                        this.$message.success("解密成功！");
                        row.mobile = res.data.mobile;
                    }
                })
            },
            //运营渠道 Cascader 级联选择器,切换事件,表单model赋值
            channelHandleChange(value) {
                // console.log('运营渠道：', value);
                if(value && value.length > 0){
                    this.filterModel.source = value[value.length - 1].toString();
                    this.channel = {
                        pid: value.length == 2 ? value[0] : 0,
                        id: value[value.length - 1],
                    };
                }else{
                    this.filterModel.source = '';
                    this.channel =  _.clone(_.extend(this.filterModel, {
                        pid: '',
                        id: '',
                    }));
                }
            },

            statusHandleChange(value){
                if(value && value.length > 0){
                    this.filterModel.status = value[0];
                    this.filterModel.status_child = value.length > 1 ? value[1] : '';
                }else{
                    this.filterModel.status = '';
                    this.filterModel.status_child = '';
                }
            },
            leaderStatusHandleChange(value){
                if(value && value.length > 0){
                    this.filterModel.leader_status = value[0];
                    this.filterModel.leader_status_child = value.length > 1 ? value[1] : '';
                }else{
                    this.filterModel.leader_status = '';
                    this.filterModel.leader_status_child = '';
                }
            },
            unbindChange(){
                this.clueIds = [];
                this.submitSearch();
            }
        },
    }
</script>


// WEBPACK FOOTER //
// src/views/clue/myclue.vue